import PropTypes from "prop-types";
import { useContext, useState } from "react";

import { StoreContext } from "../store/StoreContext";
// import GraphqlAPIcalls from '../api/graphql';
const ContactUsController = () => {
  // const { userCreate } = GraphqlAPIcalls();
  const [state] = useContext(StoreContext);
  const { userContact } = state;
  const [user, setUser] = useState(userContact);

  const [validations, setValidation] = useState({
    err: {
      company: "",
      concern: "",
      contactNumber: "",
      emailAddress: "",
      fullName: "",
      mallBranch: "",
      message: ""
    },
    err_msg: ""
  });

  // HANDLE CHANGES
  const handleChange = event => {
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setUser({ ...user, [name]: value });
    setValidation({
      ...validations,
      err_msg: ""
    });
  };

  const handleReset = () => {
    // setUser(initUser)
    setUser({
      company: "",
      concern: "",
      contactNumber: "",
      emailAddress: "",
      fullName: "",
      mallBranch: "",
      message: ""
    });
  };
  return {
    handleChange,
    handleReset,
    user,
    validations
  };
};

export default ContactUsController;

ContactUsController.propTypes = {
  company: PropTypes.string,
  contactNumber: PropTypes.string,
  emailAddress: PropTypes.string,
  fullname: PropTypes.string,
  mallBranch: PropTypes.string
};
